/**
 * Runs a callback in a task after the browser's next paint.
 *
 * The returned cleanup cancels the callback while either the animation frame or follow-up task is
 * still pending.
 */
export function afterPaint(callback: () => void): () => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  const animationFrameId = requestAnimationFrame(() => {
    timeoutId = setTimeout(callback, 0);
  });

  return () => {
    cancelAnimationFrame(animationFrameId);
    if (timeoutId != null) clearTimeout(timeoutId);
  };
}
